import type { PopupProps } from '@atlaskit/popup/types';

export function isFocusMovingRole({ role }: { role?: PopupProps['role'] }): boolean {
	return role === 'dialog' || role === 'alertdialog' || role === 'menu' || role === 'listbox';
}
